import { render } from "./ReportLoader.vue?vue&type=template&id=8b4aa2ce&ts=true"
import script from "./ReportLoader.vue?vue&type=script&lang=ts"
export * from "./ReportLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__